<div class="Loading" *ngIf="IsShowLoading == true">
    <div class="loader"></div>
    <label class="loaderlabel">Please wait while Processing....</label>
</div>





<!-- <div class="EndorsementsHolder">
    <p class="headding">{{'ENDORSEMENTS'||translate}}</p>

    <div class="EndorsementsList">
        <div class="c-dashboardInfo col-lg-3 col-md-6" *ngFor="let obj of objEndorsementMasterList; index as i">
            <div class="wrap">
                <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title">
                    <a style="cursor: pointer;" data-toggle="tooltip" title="{{obj.EndorsementShortDesc|translate}}" (click)="GoToEndorsement(obj)">{{obj.EndorsementShortDesc||translate}}
                        <i class="{{obj.CSSString}}" [ngStyle]="{'color':obj.EndorsementCode == '5' ? 'red'  : 'var(--limrasecondry)' }"></i></a>
                </h4>
                 <span class="hind-font caption-12 c-dashboardInfo__count">{{obj.EndorsementDesc}}</span> -->
                <!-- <span class="hind-font caption-12 c-dashboardInfo__subInfo">{{obj.EndorsementDesc}}</span>
            </div>
        </div>

    </div>
</div> -->

 <div class="PolicyDashboard">
    <div class="container-fluid">


        <div class="row" style="margin-top: 20px;">
            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">

                
                <div class="panel panel-default panel-table">
                    <!-- <div class="panel-heading" style="background: var(black);color:white;"> -->
                        <!-- <div> -->
                            <!-- <h5 class="panel-title">{{'Change in Passport Info' | translate}}</h5> -->
                        <!-- </div> -->
                        <div style="display: flex;justify-content: space-between;height: 28px;">
                            <h3 class="panel-title" style="font-family: Verdana;">
                                <!-- {{objBindInfoRes.GeneralInfo.EndorsementDesc|translate }}</h3> -->
                                {{'Change in Passport Info' | translate}} </h3>
                            <!-- <button class="btn-1 wireBtn" (click)="Back()"><span class="wireSpan">{{'Back' | translate}}</span></button> -->
      
                        </div>
                    
                    
              

                    <div style="padding: 20px;">
                        <div class="PaymentForm payFormCancel">
                            <div class="row" style="display: flex;justify-content:space-between;flex-wrap: wrap;">

                                <div
                                    class="card Card_Ar cardcancellationdetails col-lg-6 col-md-6 col-sm-12 col-xs-12 glascard claymorphism">
                                    <div class="policydetailshead">
                                        <h5 class="cancelpolicy">{{'Policy Info' | translate}}</h5>
                                    </div>
                                    <label class="cardfeild">
                                        <span class="lbltext">{{'Policy No'|translate}}:</span>
                                        <span class="lbldata policyno">{{objBinRes.PolicyNo}}</span>
                                    </label>
                                    <label class="cardfeild">
                                        <span class="lbltext">{{'Policy From Date'|translate}}:</span>
                                        <span class="lbldata policyno">{{objBinRes.PolicyFromDate}}</span>
                                    </label>
                                    <label class="cardfeild">
                                        <span class="lbltext">{{'Policy To Date'|translate}}:</span>
                                        <span class="lbldata policyno">{{objBinRes.PolicyToDate}}</span>
                                    </label>
                                    <label class="cardfeild">
                                        <span class="lbltext">{{'Endorsement Date'|translate}}:</span>
                                        <span class="lbldata policyno">{{minDate}}</span>
                                    </label>
                                    <label class="cardfeild">
                                        <span class="lbltext">{{'Endorsement From Date'|translate}}:</span>
                                        <span class="lbldata policyno">{{EndorsementDate}}</span>
                                    </label>
                                    <label class="cardfeild">
                                        <span class="lbltext">{{'Endorsement To Date'|translate}}:</span>
                                        <span class="lbldata policyno">{{objBinRes.PolicyToDate}}</span>
                                    </label>
                                </div>

                            </div>
                        </div>

                        <!-- <section *ngIf="objEndReq.EndorsementTypeCode==6"> -->

                            <div style="justify-content: center;">
                                <div class="tableHolder claymorphism">
                                    <table class="memberTable">
                                        <thead>
                                            <th>
                                                <p>{{'Actions'|translate}}</p>
                                            </th>
                                            <th>
                                                <p>{{'ID Number'|translate}}</p>
                                            </th>
                                            <th>
                                                <p>{{'Name'|translate}}</p>
                                            </th>
                                            <!-- <th>
                                                <p>{{'Date of Birth'|translate}}</p>
                                            </th> -->
                                            <th>
                                                <p>{{'Gender'|translate}}</p>
                                            </th>
                                            <th>
                                                <p>{{'Relation'|translate}}</p>
                                            </th>
                                            <th>
                                                <p>{{'Nationality'|translate}}</p>
                                            </th>
                                            <th>
                                                <p>{{'Passport Number'|translate}}</p>
                                            </th>
                                        </thead>
                                        <tbody>
                                             <tr *ngFor="let obj of objBindInfoRes.PassengerDetails">
                                                <td>
                                                    <div style="display: flex;gap: 10px;">
                                                        <button class="editBtn actionBtn"
                                                            (click)="EditMember(obj)">{{'Edit'|translate}}</button>
                                                    </div> 
                                                </td>
                                                <td>
                                                    <div style="display: flex;padding: 5px 10px;border-radius: 5px;">
                                                         <!-- <mat-icon style="color:lightcoral;">verified_user</mat-icon>  -->
                                                          <p style="color: black;" style="letter-spacing: 1px;" disabled>{{obj.IdentityNo}}</p> 
                                                    </div>
                                                </td>
                                                <td>
                                                    <p>{{obj.Name}}</p>
                                                </td>
                                                <!-- <td> -->
                                                    <!-- <input style="color: black;" [matDatepicker]="picker" [(ngModel)]="obj.DOB"
                                                        [max]="maxDate" disabled>
                                                    <mat-datepicker #picker></mat-datepicker> -->
                                                    <!-- <p style="color: black;" style="letter-spacing: 1px;" >[(ngModel)]="obj.DOB</p>  -->

                                                    
                                                <!-- </td> -->

                                                <td>
                                                    <select style="color: black;" [(ngModel)]="obj.Sex" disabled>
                                                        <option *ngFor="let obj of DDL.GenderList"
                                                            value="{{obj.GenderCode}}">{{Lng == "en" ? obj.GenderDesc_En
                                                            :
                                                            obj.GenderDesc_Ar}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select style="color: black !important;" [(ngModel)]="obj.RelationshipCode" disabled>
                                                        <option  *ngFor="let obj of DDL.RelationList"
                                                            value="{{obj.RelationId}}">{{Lng == "en" ?
                                                            obj.RelationNameEn :
                                                            obj.RelationNameAr}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select style="color: black;width: 75px;" [(ngModel)]="obj.Nationality" disabled>
                                                        <option *ngFor="let obj of DDL.NationalityList"
                                                            value="{{obj.cchinatcode}}">{{Lng ==
                                                            "en"?obj.cchinationality:obj.cchinationality_Ar}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <p style="color: black;">{{obj.PassportNo}}</p>
                                                </td>

                                            </tr> 
                                            <tr>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>


                            </div>

                        <!-- </section>   -->

                        <!-- <section *ngIf="objEndReq.EndorsementTypeCode==7">
                            <div class="row">
                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                    <label class="lbltext">{{'Policy Period'|translate}}</label>
                                    <select (change)="DDlPeriodChange()" class="form-control" [(ngModel)]="PolicyExtREdFlag">
                                        <option value="Extension">{{"Extension"}}</option>
                                        <option value="Reduction">{{"Reduction"}}</option>
                                    </select>
                                </div>
                                <div  *ngIf="PolicyExtREdFlag!=''">
                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'Days'|translate}}</label>
                                        <input type="number" class="form-control" (focusout)="PremiumCalEndTravel()" name="txtDays" #txtDays="ngModel"
                                            [(ngModel)]="Days">
                                    </div>

                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'Old Days'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="txtNoOfDays" #txtNoOfDays="ngModel"
                                            [(ngModel)]="objBinRes.NoOfDays">
                                    </div>
                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'Total Travelling Days'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="txtTotalDays"
                                            #txtTotalDays="ngModel" [(ngModel)]="TotalDays">
                                    </div>

                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12"
                                        *ngIf="PolicyExtREdFlag=='Reduction'">

                                        <label class="lbltext">{{'Refund Premium'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="txtRefundPremium"
                                            #txtRefundPremium="ngModel" [(ngModel)]="RefundPremium">
                                    </div>

                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12"
                                        *ngIf="PolicyExtREdFlag=='Extension'">

                                        <label class="lbltext">{{'Additional Premium'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="txtAdditionalPremium"
                                            #txtAdditionalPremium="ngModel" [(ngModel)]="AdditionalPremium">
                                    </div>

                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'Premium without Vat'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="txtRefundPremium"
                                            #txtRefundPremium="ngModel" [(ngModel)]="objBinRes.PresentPremium">
                                    </div>

                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'From Date'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="FromDate"
                                            #FromDate="ngModel" [(ngModel)]="objBinRes.PolicyFromDate">
                                    </div>
                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'To Date'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="ToDate"
                                            #ToDate="ngModel" [(ngModel)]="NewToDate">
                                    </div>

                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'Vat Amount'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="txtVatAmount"
                                            #txtVatAmount="ngModel" [(ngModel)]="VatAmount">
                                    </div>

                                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-12">

                                        <label class="lbltext">{{'Total Premium Including VAT'|translate}}</label>
                                        <input disabled type="text" class="form-control" name="txtTotalPremium"
                                            #txtTotalPremium="ngModel" [(ngModel)]="TotalPremium">
                                    </div>
                                </div>

                            </div>

                        </section> -->
                        <!-- <form #GeneralInfoForm="ngForm">
                            <div class="row">
                                <div class="ItemHolder">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 customCol">
                                        <label class="lbltext">{{'Request Notes'| translate }}</label>
                                        <textarea type="text" class="form-control" id="txtRequestNotes"
                                            name="txtRequestNotes" required
                                            [(ngModel)]="  this.objBindInfoRes.GeneralInfo.RequestNotes"
                                            #txtRequestNotes="ngModel" autocomplete="off"></textarea>
                                        <span
                                            *ngIf="txtRequestNotes.invalid && (txtRequestNotes.dirty || IsSubmitted || txtRequestNotes.touched)"
                                            class="text-danger">
                                            <div *ngIf="txtRequestNotes.errors?.required">
                                                {{'Request Notes Are Required'| translate }}
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </form> -->

                        <div style="display: flex;justify-content:center;margin-top: 20px;">
                            <button (click)="Submit()" class="btn btn-primary">{{'Submit'| translate
                                }}</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div> 

<div class="modal3 row TravelMain" style="margin: 0px; padding: 0px; opacity: 1;" *ngIf="EditMemberModal">
    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"></div>
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
        <div class="row memberModal" style="margin: 0px; padding: 0px; opacity: 1;">
            <div class="row" style="margin: 0px; padding: 0px; opacity: 1;">
                <div style="letter-spacing: 1px; margin-top: 10px;">
                    <p style="background-color: aliceblue; padding: 20px 10px; border-radius: 5px; color: var(--blue2); margin-bottom: 18px;">
                        {{'Please add member details.'|translate}}
                    </p>
                </div>

                <!-- ID Number -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <label>{{'ID Number'|translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="oneMember.IdentityNo"
                           (ngModelChange)="CheckIDAlreadyUsed(oneMember.IdentityNo)" maxlength="10" disabled>
                    <p class="errorMsg" *ngIf="validateMemberIqamaNo() == 'regex' && showMemberError">
                        {{'ID Number Must start with 1 or 2 and must be 10 digits'|translate}}
                    </p>
                </div>

                <!-- Name -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <label>{{'Name'|translate}}</label>
                    <input type="text" class="form-control" disabled [(ngModel)]="oneMember.Name">
                    <p class="errorMsg" *ngIf="validateMemberName() == 'required' && showMemberError">
                        {{'Required'|translate}}
                    </p>
                </div>

               
                <!-- <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <label>{{'Date of Birth'|translate}}</label>
                    <input type="date" class="form-control" [(ngModel)]="oneMember.DOB" [max]="maxDate" disabled>
                    <p class="errorMsg" *ngIf="validateMemberDOB() == 'required' && showMemberError">
                        {{'Required'|translate}}
                    </p>
                </div> -->

          
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <label>{{'Gender'|translate}}</label>
                    <select class="form-control"  disabled [(ngModel)]="oneMember.Sex">
                        <option *ngFor="let obj of DDL.GenderList" [value]="obj.GenderCode">
                            {{Lng == 'en' ? obj.GenderDesc_En : obj.GenderDesc_Ar}}
                        </option>
                    </select>
                    <p class="errorMsg" *ngIf="validateMemberGender() == 'required' && showMemberError">
                        {{'Required'|translate}}
                    </p>
                </div>

                <!-- Relation -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <label>{{'Relation'|translate}}</label>
                    <select class="form-control" disabled [(ngModel)]="oneMember.RelationshipCode">
                        <option *ngFor="let obj of DDL.RelationList" [value]="obj.RelationId">
                            {{Lng == 'en' ? obj.RelationNameEn : obj.RelationNameAr}}
                        </option>
                    </select>
                    <p class="errorMsg" *ngIf="validateMemberRelation() == 'required' && showMemberError">
                        {{'Required'|translate}}
                    </p>
                </div>

                <!-- Nationality -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <label>{{'Nationality'|translate}}</label>
                    <select class="form-control" disabled [(ngModel)]="oneMember.Nationality">
                        <option *ngFor="let obj of DDL.NationalityList" [value]="obj.cchinatcode">
                            {{Lng == 'en' ? obj.cchinationality : obj.cchinationality_Ar}}
                        </option>
                    </select>
                    <p class="errorMsg" *ngIf="validateMemberNationality() == 'required' && showMemberError">
                        {{'Required'|translate}}
                    </p>
                </div>

                <!-- Passport Number -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <label>{{'Passport Number'|translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="oneMember.PassportNo" maxlength="30">
                    <p class="errorMsg" *ngIf="validateMemberPassport() == 'required' && showMemberError">
                        {{'Required'|translate}}
                    </p>
                </div>

                <!-- Buttons -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" style="display: flex; justify-content: space-between; margin-top: 15px;">
                    <button class="GetInsuredBtn" style="width: 48%; padding: 10px; white-space: nowrap; height: 50px;"
                            (click)="Cancel()">{{'Cancel'|translate}}</button>
                    <button class="GetInsuredBtn" style="width: 48%; padding: 10px; white-space: nowrap; height: 50px;"
                            (click)="UPdateMember()">{{'Save Member'|translate}}</button>
                </div>

            </div>
        </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"></div>
</div>



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelAddEndorsement/TravelAddEndorsement.html